import CustomerLogoWrapper from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogoWrapper';
import {CustomerLogoRenderProps} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogo';

export const CustomerLogoLyra = ({
  colorWay,
  contextId,
  ...props
}: Omit<CustomerLogoRenderProps, 'logoViewboxAlignments' | 'title'>) => {
  return (
    <CustomerLogoWrapper
      xmlns="http://www.w3.org/2000/svg"
      logoViewboxAlignments={{
        left: 71.99,
        right: -72.01,
        top: 5,
        bottom: -3,
      }}
      title="Lyra"
      {...props}
    >
      <path
        fill="var(--userLogoColor, #123243)"
        d="M84.35 11.37l5.16 12.83 5.53-12.83h3.7L87.47 37h-3.72l3.9-8.6-6.86-17.03h3.55zm19.5.17v3.2a6.9 6.9 0 015.97-3.2h.52v3.22h-.66c-3.8 0-5.84 3.5-5.84 6.78v7.49h-3.28v-17.5h3.28zM75.27 5v17.56c0 2.54 1.69 3.07 3.45 3.15.42.02 1.58 0 1.84 0h.06v3.3h-1.9c-1.86 0-6.73-.35-6.73-5.52V5h3.28zm44 6.5a8.73 8.73 0 018.7 8.44h.02v9.07h-3.27V27.1a8.65 8.65 0 01-5.44 1.92 8.74 8.74 0 01-8.71-8.75c-.01-4.83 3.89-8.75 8.7-8.76zm-.03 3.3a5.47 5.47 0 00-5.47 5.5v.26a5.5 5.5 0 005.47 5.23 5.47 5.47 0 005.47-5.5 5.5 5.5 0 00-5.47-5.5z"
      />
    </CustomerLogoWrapper>
  );
};
